// import api from './api';

// export const loanService = {
//   async getLoans(params = {}) {
//     const response = await api.get('/loans', { params });
//     return response.data;
//   },

//   async getLoanById(id) {
//     const response = await api.get(`/loans/${id}`);
//     return response.data;
//   },

//   async applyForLoan(loanData) {
//     const response = await api.post('/loans/apply', loanData);
//     return response.data;
//   },

//   async approveLoan(id) {
//     const response = await api.put(`/loans/${id}/approve`);
//     return response.data;
//   },

//   async disburseLoan(id) {
//     const response = await api.post(`/loans/${id}/disburse`);
//     return response.data;
//   },

//   async makeRepayment(id, repaymentData) {
//     const response = await api.post(`/loans/${id}/repay`, repaymentData);
//     return response.data;
//   },

//   async rescheduleLoan(id, rescheduleData) {
//     const response = await api.post(`/loans/${id}/reschedule`, rescheduleData);
//     return response.data;
//   },

//   async getLoanProducts() {
//     const response = await api.get('/loans/products');
//     return response.data;
//   },

//   async getPendingLoans() {
//     const response = await api.get('/loans/pending');
//     return response.data;
//   },

//   async getDueLoans(daysOverdue = 0) {
//     const response = await api.get('/loans/due', { params: { days_overdue: daysOverdue } });
//     return response.data;
//   },

//   async getLoanSchedule(id) {
//     const response = await api.get(`/loans/${id}/schedule`);
//     return response.data;
//   }
// };
import api from './api';

export const loanService = {
  async getLoans(params = {}) {
    try {
      const response = await api.get('/loans', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching loans:', error);
      throw error;
    }
  },

  async getLoanById(id) {
    try {
      const response = await api.get(`/loans/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching loan:', error);
      throw error;
    }
  },

  async applyForLoan(loanData) {
    try {
      const response = await api.post('/loans/apply', loanData);
      return response.data;
    } catch (error) {
      console.error('Error applying for loan:', error);
      // Re-throw with a clean error message
      throw error;
    }
  },

  async approveLoan(id) {
    try {
      const response = await api.put(`/loans/${id}/approve`);
      return response.data;
    } catch (error) {
      console.error('Error approving loan:', error);
      throw error;
    }
  },

  async disburseLoan(id) {
    try {
      const response = await api.post(`/loans/${id}/disburse`);
      return response.data;
    } catch (error) {
      console.error('Error disbursing loan:', error);
      throw error;
    }
  },

  async makeRepayment(id, repaymentData) {
    try {
      const response = await api.post(`/loans/${id}/repay`, repaymentData);
      return response.data;
    } catch (error) {
      console.error('Error making repayment:', error);
      throw error;
    }
  },

  async getLoanProducts() {
    try {
      const response = await api.get('/loans/products');
      return response.data;
    } catch (error) {
      console.error('Error fetching loan products:', error);
      throw error;
    }
  },

  async getPendingLoans() {
    try {
      const response = await api.get('/loans/pending');
      return response.data;
    } catch (error) {
      console.error('Error fetching pending loans:', error);
      throw error;
    }
  },

  async getDueLoans(daysOverdue = 0) {
    try {
      const response = await api.get('/loans/due', { params: { days_overdue: daysOverdue } });
      return response.data;
    } catch (error) {
      console.error('Error fetching due loans:', error);
      throw error;
    }
  },

  async getLoanSchedule(id) {
    try {
      const response = await api.get(`/loans/${id}/schedule`);
      return response.data;
    } catch (error) {
      console.error('Error fetching loan schedule:', error);
      throw error;
    }
  }
};